<template>
  <ul
    v-if="visiblePaymentIcons.length"
    class="flex flex-wrap"
    :class="gapClass"
  >
    <li v-for="icon in visiblePaymentIcons" :key="icon.title">
      <PaymentMethodSymbol v-bind="{ outlined, size }" :variant="icon" />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import type { PaymentMethodSymbolProps } from '~/features/Payment/PaymentMethodSymbol.vue'

type PaymentMethodSymbols = Pick<
  PaymentMethodSymbolProps,
  'outlined' | 'size'
> & {
  filter?: string[]
  gapClass?: 'gap-050' | 'gap-100' | 'gap-200'
}

const {
  filter = [],
  gapClass = 'gap-200',
  outlined = undefined,
} = defineProps<PaymentMethodSymbols>()

const visiblePaymentIcons = usePaymentIcons(filter)
</script>
